import { Mail, Linkedin, Github } from 'lucide-react';
import { useTranslation } from 'react-i18next';

function Contact() {
  const { t } = useTranslation();

  return (
    <div className="contact">
      <h1 className="contact-title">{t('home.contactTitle')}</h1>
      <div className="contact-video">
        <iframe
          src="https://www.youtube-nocookie.com/embed/geU7XHCg0Lk"
          title={t('home.personalProjects')}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </div>
      
      <p className="contact-subtitle">
        {t('home.contactSubtitle')}
      </p>
      
      <div className="contact-cards">
        <a href="mailto:ghislainedadjo@gmail.com" className="contact-card">
          <div className="contact-icon" >
            <Mail size={20} />
          </div>
          <span className="contact-text">ghislainedadjo@gmail.com</span>
        </a>
        <a href="https://www.linkedin.com/in/nefertiti-dadjo/" target="_blank" rel="noopener noreferrer" className="contact-card">
          <div className="contact-icon" >
            <Linkedin size={20} />
          </div>
          <span className="contact-text">linkedin.com/in/nefertiti-dadjo</span>
        </a>
        <a href="https://github.com/NefertitiDadjo" target="_blank" rel="noopener noreferrer" className="contact-card">
          <div className="contact-icon">
            <Github size={20} />
          </div>
          <span className="contact-text">github.com/quantibat</span>
        </a>
      </div>
    </div>
  );
}

export default Contact;
